module.exports = __webpack_public_path__ + "img/eg.3b5ebed2.svg";